export const compareSort = (keyName, value) => (a, b) => {
  const aOk = a[keyName] === value;
  const bOk = b[keyName] === value;
  if (aOk && !bOk) return -1;
  if (bOk && !aOk) return 1;
  return 0;
};

export const includeBit = (bit, bitfield) => (bitfield & bit) === bit;
export const concatBit = (bit, bitfield) => bitfield | bit;
export const removeBit = (bit, bitfield) => bitfield & ~bit;
export const ensureBit = (bit, bitfield) =>
  includeBit(bit, bitfield) ? removeBit(bit, bitfield) : concatBit(bit, bitfield);

export const moneyBRToFloat = (moneyBR) =>
  Number(moneyBR.replace(/(R\$ )|(\.)/g, '').replace(',', '.'));

export const normalizeMoney = (money) =>
  parseFloat(money).toLocaleString('pt-BR', {
    currency: 'BRL',
    style: 'currency',
    minimumFractionDigits: 2
  });

export const hasProps = (obj, ...props) => props.reduce((prev, prop) => prev && obj[prop], true);
export const removeSpecialCharacters = (str) =>
  str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
